import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TitleService } from '../title.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  standalone: false,
})
export class SettingsComponent implements OnInit, OnDestroy {
  private titleService = inject(TitleService);

  subscriptions = new Subscription();

  ngOnInit() {
    this.titleService.set('Settings');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
